import { render } from "./PreviewAhw.vue?vue&type=template&id=33eaa983"
import script from "./PreviewAhw.vue?vue&type=script&lang=js"
export * from "./PreviewAhw.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__